import { produce } from "immer";

import { createStore } from "base/basestore";

export const createWithImmer = (uId, storeCreator) =>
  createStore(uId, (originalSet, originalGet) =>
    storeCreator((fn) => originalSet(produce(fn)), originalGet)
  );
